import { Component, OnInit } from '@angular/core';
import { ReservePageService } from './reserve.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { CommonSubProductsHeroComponent } from 'src/app/shared/components/sub-products/sub-products-hero/hero.component';
import { CommonSubProductsAlternateBlocksComponent } from 'src/app/shared/components/sub-products/alternate-blocks/alternate-blocks.component';
import { CommonSubProductsHowItWorksComponent } from 'src/app/shared/components/sub-products/how-it-works/how-it-works.component';
import { CommonFaqComponent } from 'src/app/shared/components/faq/faq-on.component';
import { CommonSubProductsDiscoverDifferenceComponent } from 'src/app/shared/components/sub-products/discover-difference/discover-difference.component';
import { CommonSubProductsPricingComponent } from 'src/app/shared/components/sub-products/pricing/pricing.component';
import { CommonSubProductsWhitePaperComponent } from 'src/app/shared/components/sub-products/white-paper/white-paper.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';

@Component({
  selector: 'app-reserve-fx',
  templateUrl: './reserve.component.html',
  styleUrls: ['./reserve.component.scss'],
  imports: [
    CommonSubProductsHeroComponent,
    CommonSubProductsAlternateBlocksComponent,
    CommonSubProductsHowItWorksComponent,
    CommonFaqComponent,
    CommonSubProductsDiscoverDifferenceComponent,
    CommonSubProductsPricingComponent,
    CommonSubProductsWhitePaperComponent,
    CommonGetstartedComponent,
  ],
})
export class ReserveComponent implements OnInit {
  heroHeader:any;
  featureData1 = [];
  featureData2 = [];
  faqData:any;
  differenceData:any;
  pricingData:any;
  getStartedData:any;
  whitePaperData:any;
  howItWorksData:any;
  storyData:any;
  constructor(
    private ReservePageService: ReservePageService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    this.ReservePageService.getReservePageData();
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let pageData = this.route.snapshot.data?.['seo'][0].fields;
    if (pageData?.seoMetadataReference?.fields.title) {
      this.metaBody.title = pageData?.seoMetadataReference?.fields.title;
    } else {
      this.metaBody.title =
        'Verto: Cross-border payments platform for businesses';
    }
    if (pageData?.seoMetadataReference?.fields.description) {
      this.metaBody.description =
        pageData?.seoMetadataReference?.fields.description;
    } else {
      this.metaBody.description =
        'Verto: Cross-border payments platform for businesses across the globe.';
    }
    this.metaBody.type = 'Spot FX';
    this.metaBody.url = this.getUrl;
    this.metaBody.image =
      pageData?.heroContentPanel?.fields?.image[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);

    if (pageData != null && pageData?.psHeroPanel?.fields) {
      const headerData = pageData?.psHeroPanel?.fields;
      this.heroHeader = {
        tagIcon: headerData?.tags?.[0]?.fields?.icon?.fields?.file?.url,
        iconTitle: headerData?.tags?.[0]?.fields?.icon?.fields?.title,
        tagName: headerData?.tags?.[0]?.fields?.tagText,
        header: headerData?.title,
        image: headerData?.image?.[0]?.fields?.file?.url,
        alt: headerData?.image?.[0]?.fields?.title,
        paragraph: headerData?.content,
        button1: {
          text: headerData?.buttons?.[0]?.fields?.buttonText,
          url: headerData?.buttons?.[0]?.fields?.redirectLink,
          target: headerData?.buttons?.[0]?.fields?.actionType,
        },
        button2: {
          text: headerData?.buttons?.[1]?.fields?.buttonText,
          url: headerData?.buttons?.[1]?.fields?.redirectLink,
          target: headerData?.buttons?.[1]?.fields?.actionType,
        },
      };
      this.featureData1 = pageData?.psFeatures?.[0]?.fields;
      this.howItWorksData = pageData?.psValuePropPanel?.fields;
      this.faqData = pageData?.psFaqPanel.fields;
      this.differenceData = pageData?.psTableFeaturesComparison?.fields;
      this.pricingData = pageData?.psPricingPanel?.fields;
      this.whitePaperData = pageData?.psWhitepaperForm?.fields;
      const startedData = pageData?.psGetStartedPanel.fields;
      this.getStartedData = {
        header: startedData.title,
        button1: {
          url: startedData?.buttons?.[0]?.fields.redirectLink,
          text: startedData?.buttons?.[0]?.fields.buttonText,
          target: startedData?.buttons?.[0]?.fields.actionType,
        },
        button2: {
          url: startedData?.buttons?.[1]?.fields.redirectLink,
          text: startedData?.buttons?.[1]?.fields.buttonText,
          target: startedData?.buttons?.[1]?.fields.actionType,
        },
      };
    }
    this.posthogService.capturePageViewEvent('reserve');
  }
}
